import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'

export const useHasPrivilege = (privilege: string) => {
  const privileges = useSelector((state: RootState) => state.auth.privileges)

  if (!privileges) {
    return false
  }

  return privileges.includes(privilege)
}
